import React from 'react';

const Button = ({
	color = '#273C89',
	variant = 'filled',
	borderColor,
	onClick,
	text,
	size = 'medium',
	padding = 'default',
	disabled = false,
	style = {},
	fontFamily,
	fontSize,
	children,
	...rest
}) => {
	const sizeClasses = {
		small: 'text-sm',
		medium: 'text-base',
		large: 'text-lg',
		xl: 'text-xl',
	};

	const paddingClasses = {
		none: 'p-0',
		small: 'px-2 py-1',
		default: 'px-4 py-2',
		large: 'px-6 py-3',
		xl: 'px-8 py-4',
	};

	const filledStyle = {
		backgroundColor: color,
		color: '#fff',
		border: `1.5px solid ${color}`,
	};
	const outlinedStyle = {
		backgroundColor: 'transparent',
		color: color,
		border: `1.5px solid ${borderColor || color}`,
	};
	const variantStyle = variant === 'outlined' ? outlinedStyle : filledStyle;

	const fontStyles = {};
	if (fontFamily) fontStyles.fontFamily = fontFamily;
	if (fontSize) fontStyles.fontSize = fontSize;

	const disabledStyle = disabled
		? variant === 'outlined'
			? {
					backgroundColor: 'transparent',
					color: '#757575',
					border: '1.5px solid #757575',
			  }
			: {
					backgroundColor: '#949494',
					color: '#fff',
					border: '1.5px solid #949494',
			  }
		: {};

	return (
		<button
			onClick={onClick}
			disabled={disabled}
			className={`btn-a11y ${sizeClasses[size]} ${paddingClasses[padding]}`}
			style={{ ...variantStyle, ...fontStyles, ...disabledStyle, ...style }}
			{...rest}
		>
			{text || children}
		</button>
	);
};

export default Button;
